import {v4} from './uuid.js'

const stashRequest = (url, reqId) => {
  if (!window.retracedApiRequests) {
    window.retracedApiRequests = []
  }

  window.retracedApiRequests.unshift({
    url,
    reqId,
  })
  window.retracedApiRequests.splice(3)
}

export const getFetchHeaders = data => {
  const retracedContext = JSON.parse(localStorage.getItem('retraced:context'))?.state
  const timezone = {'x-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone}

  const accessToken = retracedContext?.accessToken || null
  const sessionToken = retracedContext?.sessionToken || null

  const commonHeaders = data.headers || {}
  const {Authorization: authorizationHeader, 'X-Session-Token': sessionTokenHeader} = commonHeaders
  
  // Add Ory session token if not already present in headers
  if (!sessionTokenHeader && sessionToken) {
    commonHeaders['X-Session-Token'] = sessionToken
  }

  // Add Bearer token if not already present in headers
  if (!authorizationHeader && accessToken) {
    commonHeaders.Authorization = `Bearer ${accessToken}`
  }

  const impersonateHeader =
    retracedContext && retracedContext.impersonateId ? {'x-retraced-impersonate': retracedContext.impersonateId} : {}
  const auditCompanyHeader =
    retracedContext && retracedContext.auditCompanyId
      ? {'x-retraced-audit-company-id': retracedContext.auditCompanyId}
      : {}
  const companyHeader =
    retracedContext && retracedContext.companyId ? {'x-retraced-company-id': retracedContext.companyId} : {}

  const xRequestId = {'x-request-id': v4()}

  const contentTypeHeader = data.body !== undefined ? {'Content-Type': 'application/json'} : {}

  return {
    ...commonHeaders,
    ...contentTypeHeader,
    ...impersonateHeader,
    ...auditCompanyHeader,
    ...companyHeader,
    ...xRequestId,
    ...timezone,
  }
}

export const getApiOrigin = () => {
  const uri = import.meta.env.VITE_API_SERVICE_URI
  return uri ? new URL(uri).origin : ''
}

export const fetch = (rawUrl, data) => {
  const headers = getFetchHeaders(data)

  const options = {
    ...data,
    headers,
    credentials: 'include', //to include everything in the headers that came in with the response of the first request
  }

  let url = typeof rawUrl === 'string' ? `${import.meta.env.VITE_API_SERVICE_URI}${rawUrl}` : rawUrl.join('')
  return window.fetch(url, options).then(async response => {
    let data
    let responseError = null
    try {
      // Try to parse response body as JSON. Independant if error or not error response, because the API
      // might also send a message in case of errors.
      if (response.status === 401) {
        localStorage.removeItem('retraced:context')
      }

      if (response.ok) {
        data = await response.json()
      } else {
        data = null
        responseError = await response.json()
      }
    } catch {
      data = null
    }

    const reqId = response.headers.get('x-request-id')
    stashRequest(url, reqId)

    return {
      data,
      error: responseError
        ? {
            ...responseError,
            reqId,
          }
        : null,
      status: response.status,
    }
  })
}
